export const CLIENT_URL_CONTROL = 'client-url-control';
export const INVALID_CLIENT_URL = 'INVALID_CLIENT_ID';
export const INVALID_CLIENT_URL_MESSAGE = 'Client URL is not valid. Ex. https://client-url.com';
